
import Header from "../components/header.jsx";
import AdminSidebar from "../components/adminSidebar.jsx";
import AdminBillGenerate from "../components/adminBillGenerate.jsx";
import Footer from "../components/footer.jsx";

function AdminBillGeneratePage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <AdminSidebar /> 
      < AdminBillGenerate/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default AdminBillGeneratePage;
